// extracted by mini-css-extract-plugin
export default {"root":"s_1VYnQ3PDczu8VFhyWL","header":"JW40LqkvltVfyDEIddP2","logo":"gi4EFqiHACjwxxEfV4Q_","flexer":"P0h9Lpgm7ckWjwZv5w_S","item":"xYvQ_vTXqg7OqD4mms6H"};